import { Extra, ExtraTarifa, GrupoTarifa, ModalidadGrupoTarifa, Pago, Tarifa, TiposAlojamientos, TiposExtras, TiposPagos } from 'src/gql/schema'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { useDate } from 'src/shared/hooks/useDate'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'
import { formatTipoPago } from 'src/shared/helpers/formatTipoPago'
import { capitalize } from 'src/shared/helpers/capitalize'
import { useFormatDate } from 'src/shared/hooks/useFormatDate'

const ExtraDetail = ({ extra, tarifa, pago, extraTarifa, tipo_hospedaje, cantidadHospedajeExtra }: { extra: Extra, tarifa: Tarifa, fechas_renta: { fecha_registro: string, fecha_condensada: string }, grupoTarifa: GrupoTarifa, pago: Pago, extraTarifa: ExtraTarifa, tipo_hospedaje: TiposAlojamientos, cantidadHospedajeExtra?: number }) => {
    const { UTCStringToLocalDate } = useDate()
    const { formatCustomDate } = useFormatDate()
    const tipo_extra = extra.tipo_extra

    return (<Detail>
        <DetailIcon name={tipo_extra === TiposExtras.Hospedaje ? "MoonFill" : tipo_extra === TiposExtras.Hora ? "Clock" : tipo_extra === TiposExtras.Persona ? "UserParentFill" : ""} />
        <DetailContent>
            <DetailRow>
                <DetailText>
                    {tipo_extra === TiposExtras.Hospedaje ? tipo_hospedaje === TiposAlojamientos.Hotel ? "Noches extras" : "Hospedajes extras" : tipo_extra === TiposExtras.Hora ? "Horas extras" : tipo_extra === TiposExtras.Persona ? "Personas extras" : ""}
                </DetailText>
            </DetailRow>
            <DetailRow>
                {
                    tarifa.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base ?
                        <DetailText type='bold' style={{ maxWidth: "200px" }}>{capitalize(tarifa.grupo_tarifa?.modalidad)}</DetailText> :
                        <DetailText type='bold' style={{ maxWidth: "200px" }}>{capitalize(tarifa.grupo_tarifa?.modalidad || "")} -  {tarifa.grupo_tarifa?.modalidad || ""}</DetailText>
                }
                <DetailText type='bold' textAlign='right' style={{ maxWidth: "85px" }}>
                    {formatCurrencyToFixed(extraTarifa.subtotales?.total || 0)}
                </DetailText>
            </DetailRow>
            <DetailRow>
                <DetailText textSize={10}>
                    {tipo_extra === TiposExtras.Hospedaje
                        ? tipo_hospedaje === TiposAlojamientos.Motel
                            ? `${tarifa.grupo_tarifa?.duracion ?? "-"} horas | ${formatCurrencyToFixed(extraTarifa.subtotales?.precio_unitario || 0)}`
                            : `${cantidadHospedajeExtra ?? 1} ${(cantidadHospedajeExtra ?? 1) === 1 ? 'noche' : 'noches'} | ${formatCurrencyToFixed(extraTarifa.subtotales?.precio_unitario || 0)}`
                        : tipo_extra === TiposExtras.Hora
                            ? `${extra.numero ?? 1} ${(extra.numero ?? 1) === 1 ? 'hora' : 'horas'} | ${formatCurrencyToFixed(extraTarifa.subtotales?.precio_unitario || 0)}`
                            : tipo_extra === TiposExtras.Persona
                                ? `${extra.numero} personas x ${tipo_hospedaje === TiposAlojamientos.Hotel ? "noche" : "estancia"} | ${formatCurrencyToFixed(extraTarifa.subtotales?.precio_unitario || 0)} x pers.`
                                : ""}
                </DetailText>
            </DetailRow>
            <DetailRow>
                <DetailText type='bold'>
                    {formatCustomDate(UTCStringToLocalDate(pago?.fecha_pago), "MMM, DD YYYY, hh:mm A")}
                </DetailText>
                <DetailText type='bold' textAlign='right'>
                    {
                        (pago.detalles_pago?.map((dp) => [TiposPagos.Amex, TiposPagos.VisaOMastercard].includes(dp.tipo_pago) ?
                            `*${dp.ultimos_digitos || dp.numero_referencia}` : dp.tipo_pago === TiposPagos.DepositoOTransferencia ?
                                `*${dp.numero_referencia || dp.ultimos_digitos}` : formatTipoPago(dp.tipo_pago)) || []).join(" ")
                    }
                </DetailText>
            </DetailRow>
        </DetailContent>
    </Detail>
    )
}

export default ExtraDetail